var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisitLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33346 2.16634H3.83346C2.90003 2.16634 2.43298 2.16634 2.07646 2.348C1.76285 2.50779 1.50807 2.76257 1.34828 3.07617C1.16663 3.43269 1.16663 3.89975 1.16663 4.83317V11.1665C1.16663 12.0999 1.16663 12.5664 1.34828 12.9229C1.50807 13.2365 1.76285 13.4917 2.07646 13.6515C2.43263 13.833 2.89912 13.833 3.83072 13.833H10.1692C11.1008 13.833 11.5666 13.833 11.9228 13.6515C12.2364 13.4917 12.492 13.2363 12.6518 12.9227C12.8333 12.5665 12.8333 12.1005 12.8333 11.1689V9.66634M13.6666 5.49967V1.33301M13.6666 1.33301H9.49996M13.6666 1.33301L7.83329 7.16634",
    stroke: "#DA291C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitLink);
export default __webpack_public_path__ + "static/media/visit-link.a74247d76004895bbffb2a12a1b75253.svg";
export { ForwardRef as ReactComponent };